export default (that) => [
  {
    field: 'shipmentBatchCode',
    width: 50,
    align: 'center',
    type: 'seq'
  },
  {
    title: that.$l('INDEX.form_label_shipmentNo') || '发运单编号',
    field: 'shipmentNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'shipmentNo',
    },
  },
  {
    title: that.$l('INDEX.form_label_shipmentStatus') || '单据状态',
    field: 'shipmentStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'status',
    },
  },
  {
    title: that.$l('INDEX.order_form_batch_label_orderBatchNo') || '批次号',
    field: 'orderBatchNo',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_customerOrderNo') || '客户订单号',
    field: 'contractNo',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_retailerPo') || '零售商PO',
    field: 'retailerPo',
    minWidth: 140,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_importerPo') || '进口商PO',
    field: 'importerPo',
    minWidth: 110,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_batch_label_shipmentStartDate') || '客户最早交期',
    field: 'shipmentDate',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_batch_label_shipmentEndDate') || '客户最晚交期',
    field: 'shipmentEndDate',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_cargoReadyDay') || '货好时间',
    field: 'deliveryDate',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_outBillType') || '出单类型',
    field: 'outBillType',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_dispatchPort') || '发运港口',
    field: 'dispatchPort',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_destinationPort') || '目的港口',
    field: 'destinationPort',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_package_packingType') || '装箱方式',
    field: 'v_packingType',
    align: 'center',
    headerAlign: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_batchGoodsQty') || '批次产品总数量',
    field: 'batchGoodsQty',
    align: 'center',
    headerAlign: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    isTotalColumn: true,
  },
  {
    title: that.$l('INDEX.table_batchBoxQty') || '批次总箱数',
    field: 'batchBoxQty',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    isTotalColumn: true,
  },
  {
    title: that.$l('INDEX.form_totalBoxVolume') || '批次总体积（立方米）',
    field: 'batchVolume',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    isTotalColumn: true,
  },
  {
    title: that.$l('INDEX.form_totalNetWeight') || '批次总净重',
    field: 'batchNetWeight',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    isTotalColumn: true,
  },
  {
    title: that.$l('INDEX.form_totalGrossWeight') || '批次总毛重',
    field: 'batchGrossWeight',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    isTotalColumn: true,
  },
  {
    title: that.$l('INDEX.form_boxLength_cm') || '箱长（cm）',
    field: 'boxLength',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_boxWidth_cm') || '箱宽（cm）',
    field: 'boxWidth',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_boxHeight_cm') || '箱高（cm）',
    field: 'boxHeight',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_boxVolume') || '箱体积(m³)',
    field: 'boxVolume',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_Batch Price Amount') || '工厂金额',
    field: 'batchPriceAmount',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'batchAmount',
    },
    isTotalColumn: true,
  },
  {
    title: that.$l('INDEX.form_shipmentSalePrice') || '批次销售总价',
    field: 'batchSalePriceAmount',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'batchSalePrice',
    },
    isTotalColumn: true,
  },
]
